import React from 'react';
import { translateCategory } from '../utils/i18n';
import translations from '../utils/translations';
import { sanitizeUrl } from '../utils/links';
import { FaSpotify, FaYoutube, FaMusic } from 'react-icons/fa';

const SimpleSongCard = ({ song, onToggleSelect, onShowDetail, showCategory, currentLanguage, background }) => {
  const t = translations[currentLanguage] || translations['Español'];
  const tLangs = translations[currentLanguage]?.languages || {};

  // 🎨 Estilos de la tarjeta con fondo
  const cardStyle = {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div
      style={cardStyle}
      className={`rounded-xl shadow-lg p-4 flex items-center justify-between hover:shadow-xl transition-all duration-300 ${
        song.selected ? 'ring-2 ring-yellow-400' : ''
      }`}
    >
      {/* Capa translúcida para mejorar legibilidad del texto */}
      <div className="bg-black bg-opacity-25 rounded-xl p-4 flex-1 flex items-center justify-between">
        <div className="flex-1 min-w-0">
          <h3
            className="text-lg font-semibold text-white cursor-pointer hover:text-gray-200"
            onClick={() => onShowDetail(song)}
          >
            {song.title}
          </h3>

          {/* Chips de categoría e idioma */}
          <div className="flex flex-wrap gap-2 mt-1">
           {showCategory && (song.categories || [song?.category]).filter(Boolean).map((cat) => (
  <span
    key={cat}
    className="inline-block bg-gray-800 bg-opacity-70 rounded-full px-2 py-0.5 text-xs font-medium text-white"
  >
    {translateCategory(cat, currentLanguage)}
  </span>
))}

            {song.language && (
              <span className="inline-block bg-yellow-400 text-black rounded-full px-2 py-0.5 text-xs font-medium">
                {tLangs[song.language] || song.language}
              </span>
            )}
          </div>

          {/* Enlaces con iconos */}
          <div className="flex flex-wrap gap-2 mt-2">
            {song.spotify && (
              <a
                href={sanitizeUrl(song.spotify)}
                target="_blank"
                rel="noopener noreferrer"
                className="p-1 rounded bg-green-600 text-white hover:bg-green-700"
                title={t.listenOnSpotify}
              >
                <FaSpotify size={16} />
              </a>
            )}
            {song.youtube && (
              <a
                href={sanitizeUrl(song.youtube)}
                target="_blank"
                rel="noopener noreferrer"
                className="p-1 rounded bg-red-600 text-white hover:bg-red-700"
                title={t.watchOnYouTube}
              >
                <FaYoutube size={16} />
              </a>
            )}
            {song.sheetMusic && (
              <a
                href={sanitizeUrl(song.sheetMusic)}
                target="_blank"
                rel="noopener noreferrer"
                className="p-1 rounded bg-blue-600 text-white hover:bg-blue-700"
                title={t.viewSheetMusic}
              >
                <FaMusic size={16} />
              </a>
            )}
          </div>
        </div>

        {/* Botones de acción */}
        <div className="flex items-center space-x-3 ml-4">
          <button
            onClick={() => onShowDetail(song)}
            className="p-2 text-white hover:text-yellow-300 transition-colors"
            title={t.viewDetails}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
            </svg>
          </button>
          <button
            onClick={() => onToggleSelect(song.id)}
            className={`p-2 rounded-full ${
              song.selected 
                ? 'bg-yellow-400 text-black' 
                : 'bg-gray-200 text-white hover:bg-gray-300'
            }`}
            title={song.selected ? t.deselectSong : t.selectSong}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SimpleSongCard;
